import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
    IAnalysisReportState,
    ICreateReportRequestType,
    IFetchReportListType,
    IFetchSingleReportType,
    IFetchUserSkillsStatsResponse,
} from '@shared/models';
import { fetchAnalysisReportList, fetchSingleReport, fetchUserSkillsStatistics } from '../queries/report.queries';

const initialState: IAnalysisReportState = {
    list: {
        data: [],
        fetching: false,
    },
    single: {
        data: null,
        fetching: false,
    },
    formValues: null,
    skillsStatistics: {
        data: null,
        fetching: false,
    },
};

const analysisReportSlice = createSlice({
    name: 'analysis-report',
    initialState,
    reducers: {
        setFormValues: (state, { payload }: PayloadAction<Partial<ICreateReportRequestType>>) => {
            if (payload) {
                state.formValues = {
                    ...state.formValues,
                    ...payload,
                };
            } else {
                state.formValues = null;
            }
        },
        setReportList: (state, { payload }: PayloadAction<IFetchReportListType>) => {
            state.list.data = payload;
        },
        setSingleReport: (state, { payload }: PayloadAction<IFetchSingleReportType>) => {
            state.single.data = payload;
        },
        setSkillStatistics: (state, { payload }: PayloadAction<IFetchUserSkillsStatsResponse>) => {
            if (payload?.baseline && payload?.stats) {
                state.skillsStatistics.data = payload;
            } else {
                state.skillsStatistics.data = {
                    baseline: payload?.baseline,
                    stats: payload?.stats,
                };
            }
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchAnalysisReportList.pending, (state) => {
            state.list.fetching = true;
        });
        builder.addCase(fetchAnalysisReportList.rejected, (state) => {
            state.list.fetching = false;
        });
        builder.addCase(fetchAnalysisReportList.fulfilled, (state) => {
            state.list.fetching = false;
        });
        builder.addCase(fetchSingleReport.pending, (state) => {
            state.single.fetching = true;
        });
        builder.addCase(fetchSingleReport.rejected, (state) => {
            state.single.fetching = false;
        });
        builder.addCase(fetchSingleReport.fulfilled, (state) => {
            state.single.fetching = false;
        });
        builder.addCase(fetchUserSkillsStatistics.pending, (state) => {
            state.skillsStatistics.fetching = true;
        });
        builder.addCase(fetchUserSkillsStatistics.rejected, (state) => {
            state.skillsStatistics.fetching = false;
        });
        builder.addCase(fetchUserSkillsStatistics.fulfilled, (state) => {
            state.skillsStatistics.fetching = false;
        });
    },
});

export const { setFormValues, setReportList, setSingleReport, setSkillStatistics } = analysisReportSlice.actions;
export default analysisReportSlice.reducer;
